<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        <p-floatlabel variant="on">
            <input id="name" type="text" pInputText formControlName="name" />
            <label for="name">Name</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <textarea id="description" rows="5" cols="30" pInputTextarea formControlName="description"></textarea>
            <label for="description">Description</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-select
                [options]="_oo8Connectors"
                formControlName="oo8_connector_uuid"
                optionLabel="name"
                optionValue="uuid"
                inputId="oo8_connector_uuid"
                id="oo8_connector_uuid"
                appendTo="body"
                [showClear]="true"
            ></p-select>
            <label for="oo8_connector_uuid">OO8 Connector</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-select
                [options]="_s3Buckets"
                formControlName="s3_bucket_uuid"
                optionLabel="name"
                optionValue="uuid"
                inputId="s3_bucket_uuid"
                id="s3_bucket_uuid"
                appendTo="body"
            ></p-select>
            <label for="s3_bucket_uuid">S3 Bucket</label>
        </p-floatlabel>
    </app-ibase-cru-modal-content>
</form>
